import { OptionsModel } from '@d-components/form/form.interface';

export const AppConstant = {
  LocalStorageKey: {
    DIALOGCoreSelected: 'DIALOGCoreSelected',
    DIALOGTenantSelected: 'DIALOGTenantSelected',
    DIALOGCompanySelected: 'DIALOGCompanySelected',
    DIALOGCurrentUserLogged: 'DIALOGCurrentUserLogged',
    DIALOGCurrentRolesLogged: 'DIALOGCurrentRolesLogged',
    DIALOGAFSelected: 'DIALOGAFSelected',
    DIALOGLSNSelected: 'DIALOGLSNSelected',
    DIALOGLTNSelected: 'DIALOGLTNSelected',
    DIALOGLTSNSelected: 'DIALOGLTSNSelected',
    DIALOGCurrentBreadCrums: 'DIALOGCurrentBreadCrums',
    DIALOGUser: 'DIALOGUser',
    DIALOGUAMTab: 'DIALOGUAMTab',
    DIALOGTenantCurrency: 'DIALOGTenantCurrency',
  },
  Style: {
    CustomLightTheme: 'custom-light-theme.css',
    CustomDarkTheme: 'custom-dark-theme.css',
    InvisibleCharacter: ' ', // unicode: U+0020 SPACE | This is not same string.Empty, for more reference: https://invisible-characters.com/
  },

  RegexPattern: {
    NotEmptyString: '/(.|s)*S(.|s)*/',
  },

  RecordStatus: {
    DRAFF: 0,
    ACTIVE: 1,
    INACTIVE: 2,
  },

  SystemLevel: {
    Tenant: 1,
    ProgramOwner: 2,
  },

  NavigateOperationMode: {
    Create: 1,
    Update: 2,
    Details: 3,
  },

  FrequencyTypeValue: {
    OneTime: 0,
    Daily: 1,
    Weekly: 2,
    BiWeekly: 3,
    BiMonthly: 4,
    Monthly: 5,
    Custom: 6,
  },

  SettlementGroup: {
    Merchant: 0,
    Reimbursement: 1,
    ServiceFee: 2,
  },

  InvoiceGroup: {
    Subscription: 0,
    Reimbursement: 1,
  },

  AssetTypeCode: {
    SIM_Card: 'SIM_Card',
    EDC_Terminal: 'EDC_Terminal',
    Barcode_Scanner: 'Barcode_Scanner',
  },

  MAX_INT: 1000000,

  TENANT_LEVEL: 'TENANT_LEVEL',
  PO_LEVEL: 'PO_LEVEL',
  CURRENT_LEVEL: 'CurrentLevel',
  EVENT: {
    CHANGE_LEVEL: 'CHANGE_LEVEL',
  },
  EMPTY: 'EMPTY',

  ReportingButtionAction: {
    Reset: 'Reset',
    Generate: 'Generate',
    SubmitNewReport: 'Submit_New_Report',
    CheckDownloadStatus: 'Check_Download_Status',
  },
};

export const ROW_PER_PAGE_DEFAULT = 15;

export const MAX_LENGTH_DEFAULT = 250;

export enum ImportApplicationStatusConstant {
  PENDING,
  VALIDATION_DATA,
  VALIDATION_DATA_FAIL,
  PROCESSING,
  COMPLETED,
  CANCEL,
  VALIDATION_DATA_COMPLETED,
  JOIN_APPROVAL_FLOW,
}

export const AUDIT_TRAIL_OPTION: OptionsModel[] = [
  {
    value: 'Added',
    label: 'CREATE',
  },
  {
    value: 'Deleted',
    label: 'DELETE',
  },
  {
    value: 'Modified',
    label: 'UPDATE',
  },
];
